// extracted by mini-css-extract-plugin
module.exports = {"image-upload":"image-upload_image-upload__GyUez","image-upload__input":"image-upload_image-upload__input__XoFxg","image-upload__button":"image-upload_image-upload__button__SLvXz"};